/* eslint-disable no-restricted-imports */
import snakecase from 'lodash.snakecase';

export function environmentCase(name: string) {
  return snakecase(name)
    .toUpperCase()
    .replace(/_\d+/g, (r) => {
      return r.replace('_', '');
    });
}
